export const getCamelCaseKey = (key: string): string => {
    return key ? key.charAt(0).toLowerCase() + key.slice(1) : key;
};
